import { render, staticRenderFns } from "./ModalInventoryProductCategory.vue?vue&type=template&id=0d2fb3a0"
import script from "./ModalInventoryProductCategory.vue?vue&type=script&lang=js"
export * from "./ModalInventoryProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports